// frontend/src/pages/PartnerTerms.js
//
// The agreement a partner accepts from their dashboard. The version stamped
// onto that acceptance is the backend's PARTNER_TERMS_VERSION, so it is read
// from the company endpoint rather than written here — a page that names its own
// version is a page that will disagree with the record of what was accepted.
import React from 'react';
import LegalDoc from '../components/LegalDoc';
import { useCompany } from '../utils/useCompany';

export default function PartnerTerms() {
  const company = useCompany();
  return (
    <LegalDoc
      namespace="partnerTerms"
      values={{
        version: company.partnerTermsVersion || company.termsVersion,
        // Interpolated rather than written into the text, because it is
        // configurable (AFFILIATE_HOLD_DAYS) and a contract that states a
        // different number from the one the software enforces is worse than one
        // that states none.
        hold: company.affiliateHoldDays ?? 14,
      }}
    />
  );
}
